<template>
  <LoginFormContainer>
    <template #title>Single sign-on (SSO)</template>

    <template #form>
      <LoadingCircle v-if="loading" />
      <PPrimaryButton
        v-else
        :color="PwcTheme.colors.darkGreyButton"
        @click="backendLogin"
      >
        Single sign-on (SSO)
      </PPrimaryButton>
    </template>
  </LoginFormContainer>
</template>

<script setup lang="ts">
import LoadingCircle from "@/components/custom/LoadingCircle.vue";
import LoginFormContainer from "@/views/login-view/LoginFormContainer.vue";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import { RouterPath } from "@/models/enum/routerPath";
import { useAuthenticationStore } from "@/stores/authentication";
import { useSnackBarStore } from "@/stores/snackBarStore";
import { ref } from "vue";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { PwcTheme } from "@/plugins/pwc-theme";

const authStore = useAuthenticationStore();
const snackbarStore = useSnackBarStore();
const router = useRouter();

const loading = ref(false);

onBeforeMount(async () => {
  try {
    loading.value = true;
    await authStore.getAuthenticationStatus();

    if (authStore.authenticated) {
      router.push(RouterPath.Home);
    }
  } catch (error) {
    snackbarStore.showError("Unable to sign in");
  } finally {
    loading.value = false;
  }
});

async function backendLogin() {
  window.location.href = "/api/authenticate/sso-login/";
}
</script>
